<template>
  <div v-if="isReady">
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-city"></i> Rozdział budów</h3>
      </div>
      <div class="portlet-body">
        <ConstructionsSearchPanel
          :assignEnable="true"
          :search="search"
          v-on:search="this.handleSearch"
        />
        <b-table
          class="table table-sm table-list table-mobilepro"
          id="constructionsDivision"
          ref="constructions_table"
          :fields="fields"
          :busy.sync="isBusy"
          :items="filtered"
          stacked="xl"
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>
          <template v-slot:head(name)>
            <div style="width: 180px">
              Nazwa / Status
              <br />
            </div>
          </template>
          <template v-slot:head(dates-start)>
            <div>
              Rozpoczęcie
            </div>
          </template>
          <template v-slot:head(dates-end)>
            <div>
              Zakończenie
            </div>
          </template>
          <template v-slot:cell(name)="data">
            {{ data.item.name }}
            <br />
            <b-badge :variant="classStatus(data.item.status)">{{
              statusName(data.item.status)
            }}</b-badge>
          </template>
          <template v-slot:cell(dates-start)="data">
            <i v-if="data.item.start_date">{{  data.item.start_date }}</i>
            <i v-else>{{ data.item.planned_start_date }}</i>
          </template>
          <template v-slot:cell(dates-end)="data">
            <i v-if="data.item.end_date">{{  data.item.end_date }}</i>
            <i v-else>{{ data.item.planned_end_date }}</i>
          </template>
          <template v-slot:cell(user_id)="data">
            <b-form-group label label-cols-lg="0">
              <b-form-select
                :options="availableEmployees('onlyEmployee')"
                size="sm"
                v-model="data.item.user_id"
                @change="updateManager(data.item.id, data.item.user_id)"
              ></b-form-select>
            </b-form-group>
          </template>
          <template v-slot:cell(finishers)="data">
            <ConstructionSubcontractorsSelect
              :position="availablePositions[0]"
              :index="0"
              :selected="data.item.selected[0]"
              size="sm"
              @update="updateSubcontractor"
            />
          </template>
          <template v-slot:cell(electric)="data">
            <ConstructionSubcontractorsSelect
              :position="availablePositions[1]"
              :index="1"
              :selected="data.item.selected[1]"
              size="sm"
              @update="updateSubcontractor"
            />
          </template>
          <template v-slot:cell(sanitary)="data">
            <ConstructionSubcontractorsSelect
              :position="availablePositions[2]"
              :index="2"
              :selected="data.item.selected[2]"
              size="sm"
              @update="updateSubcontractor"
            />
          </template>
          <template v-slot:cell(ground)="data">
            <ConstructionSubcontractorsSelect
              :position="availablePositions[3]"
              :index="3"
              :selected="data.item.selected[3]"
              size="sm"
              @update="updateSubcontractor"
            />
          </template>
          <template v-slot:cell(extra)="data">
            <b-button
              class="btn btn-light btn-collapse"
              v-b-toggle="'workerCollaps-' + data.item.id"
              ><i class="fas fa-chevron-down"></i
            ></b-button>
            <b-collapse
              v-bind:id="'workerCollaps-' + data.item.id"
              class="mb-2"
            >
              <br />
              <ConstructionSubcontractorsSelect
                :position="availablePositions[4]"
                :index="4"
                :selected="data.item.selected[4]"
                size="sm"
                @update="updateSubcontractor"
              />
              <br />
              <ConstructionSubcontractorsSelect
                :position="availablePositions[4]"
                :index="5"
                :selected="data.item.selected[5]"
                size="sm"
                @update="updateSubcontractor"
              />
              <br />
              <ConstructionSubcontractorsSelect
                :position="availablePositions[4]"
                :index="6"
                :selected="data.item.selected[6]"
                size="sm"
                @update="updateSubcontractor"
              />
              <br />
              <ConstructionSubcontractorsSelect
                :position="availablePositions[4]"
                :index="7"
                :selected="data.item.selected[7]"
                size="sm"
                @update="updateSubcontractor"
              />
            </b-collapse>
          </template>
        </b-table>
      </div>
    </div>
  </div>
  <div v-else>
    <TableSpiner />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConstructionService from "@/services/construction.service";
import TableSpiner from "../components/TableSpiner";
import ConstructionsSearchPanel from "../components/construction/ConstructionsSearchPanel";
import ConstructionSubcontractorsSelect from "@/components/construction/ConstructionSubcontractorsSelect";

export default {
  name: "TheConstractionDivision",
  components: {
    TableSpiner,
    ConstructionsSearchPanel,
    ConstructionSubcontractorsSelect,
  },
  data() {
    return {
      isReady: false,
      isBusy: false,
      items: null,
      fields: [
        { key: "name", label: "Nazwa" },
        { key: "dates-start", label: "Planowano/rozpoczęto" },
        { key: "dates-end", label: "Planowano/zakończono" },
        { key: "user_id", label: "Kierownik" },
        { key: "finishers", label: "Wykończenie" },
        { key: "electric", label: "Elektryk" },
        { key: "sanitary", label: "Hydraulika" },
        { key: "ground", label: "Podłogarz" },
        { key: "extra", label: "Prace dodatkowe" },
      ],
    };
  },
  computed: {
    ...mapGetters("division", ["search"]),
    ...mapGetters("app", [
      "availablePositions",
      "availableEmployees",
      "statusName",
      "classStatus",
    ]),
    filtered() {
      if (this.search.assign === true) {
        let filteredProjects = [];
        for (var i = 0; i < this.items.length; i++) {
          for (var j = 0; j < 4; j++) {
            if (this.items[i].selected[j].user_id === null) {
              filteredProjects.push(this.items[i]);
              j = 4;
            }
          }
        }
        return filteredProjects;
      }
      return this.items;
    },
  },
  created() {
    // this.isReady = true;
    let loadQueue = [
      this.loadAvailableEmployees(),
      this.loadAvailablePositions(),
    ];
    Promise.all(loadQueue).then(() => {
      this.isReady = true;
      this.handleSearch();
    });
  },
  methods: {
    //searchDivision
    ...mapActions("division", ["doSearch"]),
    ...mapActions("app", ["loadAvailableEmployees", "loadAvailablePositions"]),
    findSubcontractor(position_id) {
      return {
        position_id: position_id,
        user_id: null,
      };
    },
    handleSearch(query) {
      if (this.$_.isEmpty(query) === false) {
        this.$store.commit("division/search", query);

        if (query.type === "assign") {
          this.$refs.constructions_table.refresh();
          return;
        }
      }

      this.getConstructions().then(() => {
        this.isBusy = false;
      });
    },
    getConstructions() {
      //   if (this.$_.isNull(this.items) === false) {
      //     return this.items;
      //   }
      this.$Progress.start();
      this.isBusy = true;
      return ConstructionService.searchDivision(this.search)
        .then((results) => {
          results.forEach((item) => {
            item.selected = this.setSelected(item);
            delete item.subcontractors;
          });
          this.items = results;
          return this.items;
        })
        .catch(() => {
          return [];
        });
    },
    updateManager(construction_id, user_id) {
      this.$Progress.start();
      ConstructionService.manager(construction_id, user_id);
    },
    updateSubcontractor(selected, newUserId) {
      this.$Progress.start();
      ConstructionService.subcontractor(selected.construction_id, {
        subcontractor: {
          id: selected.id,
          position_id: selected.position_id,
          user_id: newUserId,
        },
      })
        .then((response) => {
          if (response && selected.id === null && newUserId >= 0) {
            selected.id = response.constructionsSubcontractorsId;
          } else if (newUserId === null) {
            selected.id = null;
          }
          selected.user_id = newUserId;
        })
        .catch(() => {
          //   selected.user_id = selected.orginal_user_id;
        });
    },
    setSelected(item) {
      let selected = [
        {
          id: null,
          position_id: 1,
          user_id: null,
          construction_id: item.id,
        },
        {
          id: null,
          position_id: 2,
          user_id: null,
          construction_id: item.id,
        },
        {
          id: null,
          position_id: 3,
          user_id: null,
          construction_id: item.id,
        },
        {
          id: null,
          position_id: 4,
          user_id: null,
          construction_id: item.id,
        },
        {
          id: null,
          position_id: 5,
          user_id: null,
          construction_id: item.id,
        },
        {
          id: null,
          position_id: 5,
          user_id: null,
          construction_id: item.id,
        },
        {
          position_id: 5,
          user_id: null,
          construction_id: item.id,
        },
        {
          id: null,
          position_id: 5,
          user_id: null,
          construction_id: item.id,
        },
      ];
      if (item.subcontractors && item.subcontractors.length > 0) {
        this.$_.each(item.subcontractors, (subcontractor) => {
          let that = this.$_.find(selected, {
            position_id: subcontractor.position_id,
            user_id: null,
          });
          if (that) {
            that.id = subcontractor.id;
            that.user_id = subcontractor.user_id;
            that.construction_id = item.id;
            (that.firstname = subcontractor.firstname),
              (that.lastname = subcontractor.lastname);
          }
        });
      }
      return selected;
    },
  },
};
</script>
